<template>
  <div>
    <div>
      <label>
        <span>
          <input type="checkbox" :checked="source.isSelected" @input.stop="parent.filterSelected(source, 'careerCategory')"></input>
        </span>
        <span class="input_txt">
          {{source.key}}
        </span>
      </label>
    </div>
    <div class="count" v-if="parent.showFacetCounts" :title="source.doc_count">[{{source.doc_count}}]</div>
  </div>
</template>

<script>
export default {
  name: 'careerCategoryItem',
  props: {
  	parent: {
  		type: Object
  	},
  	index: {
      type: Number
    },
    source: {
      type: Object,
      default() {
        return {}
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/app/explore/components/CareerCategoryItem.vue